import React, { useState } from "react";

const ProfileImageWithFullscreen = ({ imageUrl }) => {
  const [fullscreen, setFullscreen] = useState(false);

  return (
    <>
      {/* Thumbnail */}
      <div className="relative inline-block group">
        <img
          src={imageUrl}
          alt="profile"
          className="w-20 h-20 rounded-xl object-cover border border-gray-200 shadow-md transition-transform duration-300 group-hover:scale-105"
        />

        {/* Fullscreen icon on hover */}
        <button
          onClick={() => setFullscreen(true)}
          className="absolute top-1.5 right-1.5 bg-white/90 hover:bg-white text-gray-700 shadow-lg rounded-full p-1.5 opacity-0 group-hover:opacity-100 transition-all duration-300"
        >
          <img src="/show-full.svg" alt="Full Screen" className="w-4 h-4" />
        </button>
      </div>

      {/* Fullscreen Modal */}
      {fullscreen && (
        <div
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center animate-fadeIn"
          onClick={() => setFullscreen(false)}
        >
          {/* Close button */}
          <button
            onClick={() => setFullscreen(false)}
            className="absolute top-6 right-6  p-2 shadow-lg transition-transform hover:scale-110"
          >
            <img src="/add.svg" alt="Close" className="w-full h-full" />
          </button>

          {/* Fullscreen Image */}
          <img
            src={imageUrl}
            alt="Fullscreen"
            className="w-[70vw] h-[90vh] object-contain"
            onClick={(e) => e.stopPropagation()} // prevent modal close when clicking image
          />
        </div>
      )}
    </>
  );
};

export default ProfileImageWithFullscreen;
